import { render, staticRenderFns } from "./CategoryPreviewCard.vue?vue&type=template&id=421f31c6&scoped=true"
import script from "./CategoryPreviewCard.vue?vue&type=script&lang=js"
export * from "./CategoryPreviewCard.vue?vue&type=script&lang=js"
import style0 from "./CategoryPreviewCard.vue?vue&type=style&index=0&id=421f31c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421f31c6",
  null
  
)

export default component.exports